import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitch-simple",
  "use": "twitch-simple-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"twitch-simple\">\n<path d=\"M9.75 4L6 7.92857V22.0714H10.5V26L14.25 22.0714H17.25L24 15V4H9.75ZM22.5 14.2143L19.5 17.3571H16.5L13.875 20.1071V17.3571H10.5V5.57143H22.5V14.2143Z\" fill=\"white\" />\n<path d=\"M20.25 8.32137H18.75V13.0357H20.25V8.32137Z\" fill=\"white\" />\n<path d=\"M16.125 8.32137H14.625V13.0357H16.125V8.32137Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol